import * as React from 'react';
import * as ReactDOM from 'react-dom';

import PulseApp from './PulseApp';

ReactDOM.render(<PulseApp />, document.getElementById('pulse-app'));
